export default "__VITE_ASSET__CsTMDOpc__"